import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/equipment/_layout/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/equipment/settings/equipment-types" });
  },
});
